app.controller('UserFundController', ['$scope', '$location', '$routeParams', 'WdHttpService',
    'sessionService', '$timeout', 'config', '$sce', 'analyticsService', '$ocLazyLoad',
    function ($scope, $location, $routeParams,
        WdHttpService, sessionService, $timeout, config, $sce, analyticsService, $ocLazyLoad) {
        $ocLazyLoad.load([config.ENACH_SDK_URL]);
        // Init 
        $scope.init = async function () {
            await $scope.fetchAdviserSiteDetails();
            $scope.fundName = $routeParams.fund;
            $scope.adviserUsername = $routeParams.adviser;

            $scope.isEnachEnabled = $scope.isAdviserPropertyEnabled($scope.adviserUsername, 'eNachEnabled');
            $scope.isPaytmDisabled = $scope.isAdviserPropertyEnabled($routeParams.adviserUsername, 'paytmDisabled');
            $scope.payment_type = $scope.isEnachEnabled ? "enach" : "paytm"; // select the default option for the user

            if (!$scope.brokerName) {
                if (!$scope.getBrokerName()) {
                    await $scope.updateBrokerPopup();
                    return;
                }
            }
            $scope.showGraphButton = true;
            $scope.showGraphSelectBox = false;
            $scope.benchmark = 'Nifty 50'; //default value if none is selected
            $scope.radio_investment_type = "LUMPSUM";
            $scope.period = 'INCEPTION';
            $scope.fund_details = undefined;
            $scope.sipList = [];
            $scope.userFundsList = [];
            $scope.addMorePaymentModal = true;
            $scope.paymentDetailModal = false;
            $scope.fee_key = "";
            $('#my-portfolio').addClass('active');
            var cog_profile = await WdHttpService._cognito_profile(false);
            $scope.brokerName = getProfileValueFor("custom:brokerName1", cog_profile);
            $scope.showPageLoader();
            await $scope.refreshPerformance();
            await $scope.userFund();
            WdHttpService._get_dynamodb_user_profile()
                .then(response => {
                    if (response.advisoryFee[$scope.fundName] && response.advisoryFee[$scope.fundName].hasOwnProperty('expiryDate')) {
                        var today = new Date();
                        var renewalDay = new Date(response.advisoryFee[$scope.fundName].expiryDate);
                        // var months = Math.floor((renewalDay - today) / (1000 * 60 * 60 * 24 * 30));
                        $scope.feeExpiryDays = Math.floor((renewalDay - today) / (1000 * 60 * 60 * 24));

                        if ($scope.feeExpiryDays > 0) {
                            $scope.paymentRenewalDate = renewalDay.toDateString() + ', ' + $scope.feeExpiryDays + " Day";
                            if ($scope.feeExpiryDays > 1) $scope.paymentRenewalDate = $scope.paymentRenewalDate + 's';
                        }
                        $scope.$evalAsync();
                    }
                }).catch(error => console.log(error));
            $scope.hidePageLoader();

            document.addEventListener("wheel", function (event) {
                if (document.activeElement.type === "number" &&
                    document.activeElement.classList.contains("noscroll")) {
                    document.activeElement.blur();
                }
            });
        }

        $scope.refreshPerformance = async function () {

            var data = {
                investingMode: $scope.investingMode
            };
            $scope.showPageLoader();
            await WdHttpService._refresh_my_portfolio(data)
                .catch(error => {
                    $scope.hidePageLoader();
                    $scope.showErrorPopup('Failed to update your performance as of now, retry again later.');
                    console.error(error);
                });
        }

        $scope.showPerformanceGraph = function () {
            $scope.showGraphSelectBox = true;
            $scope.showGraphButton = false;
            $scope.showGraph = true;
            $scope.getPerformanceGraph();
        }

        $scope.getPastPeriod = function (item) {
            $scope.period = item;
            angular.element(document.querySelector(".btn-xs-small")).removeClass("disabled");
        }
        $scope.getBenchmarkData = function (benchmark) {
            $scope.benchmark = benchmark;
            angular.element(document.querySelector(".btn-xs-small")).removeClass("disabled");
        }

        $scope.stockSort = function (stockA, stockB) {
            if (stockA.symbol === 'Cash')
                return 1;
            return ('' + stockA.symbol).localeCompare(stockB.symbol);
        }

        $scope.userFund = async function () {
            var adviserUsername = $routeParams.adviser;
            var fundName = $routeParams.fund;

            var data = { investingMode: $scope.investingMode };
            $scope.showPageLoader();
            await WdHttpService._user_fund(data, adviserUsername, fundName)
                .then(async function (response) {
                    if (response.status == 200) {

                        $scope.adviserUsername = response.data.adviserUsername;
                        $scope.netPortfolioValue = response.data.currentValue;
                        $scope.myFundDataNumbers = response.data;
                        $scope.fundName = response.data.fundName;
                        $scope.displayName = response.data.displayName;
                        $scope.investmentType = typeof response.data.investmentType == 'string' ? response.data.investmentType.toUpperCase() : undefined;
                        $scope.userFundsList = response.data.advisePerformances;
                        $scope.userFundsList.sort($scope.stockSort);
                        google.charts.load('current', { 'packages': ['corechart'] });
                        google.charts.setOnLoadCallback(drawChart);

                        function drawChart() {
                            var userCompositiondata = new google.visualization.DataTable();
                            userCompositiondata.addColumn('string', 'Symbol');
                            userCompositiondata.addColumn('number', 'Allocation');
                            var portfolioData = $scope.userFundsList;
                            angular.forEach(portfolioData, function (value, key) {
                                userCompositiondata.addRows([
                                    [value.symbol, value.allocation]
                                ]);
                            });

                            var userCompositionoptions = {
                                title: '',
                                pieSliceText: 'none',
                                colors: ['#516091', '#74bec1', '#adebbe', '#eef3ad', '#fad9ad', '#ffb6c1'],
                                pieSliceBorderColor: 'transparent',
                                legend: 'bottom',
                                chartArea: { 'width': '90%', 'height': '80%', left: 0 },
                                titleTextStyle: {
                                    color: '#333',
                                    fontSize: '10'
                                },
                                pieSliceTextStyle: {
                                    color: '#333',
                                    fontSize: '10'
                                }
                            };
                            var userCompositionchart = new google.visualization.PieChart(document.getElementById('piechartFast'));
                            userCompositionchart.draw(userCompositiondata, userCompositionoptions);
                        }
                        await $scope.getFundDetails();
                    }
                }).catch(error => {
                    console.error(error);
                    $scope.hidePageLoader();
                });
        }

        $scope.withdrawModalOpen = async function () {
            $scope.withdrawFundValue = $scope.netPortfolioValue;
            $scope.withdrawFundName = $scope.fundName;
            $scope.withdrawFundAdviserUsername = $scope.adviserUsername;
            $scope.withdrawAmount = true;
            $scope.confirmWithdrawError = false;
            $scope.withdrawError = false;
            $('#dw_withdraw_amount').val('');
            $scope.withdraw_amount = '';
            $scope.lumpAmount = '';
            $('#withdrawPartiallyModal').modal('show');
            var eventData = {
                'fundName': $scope.fundName.toLowerCase()
            };
            await analyticsService._push_custom_event_data_to_datalayer('withdraw-partially-modal-opened', eventData);
        }

        $scope.confirmWithdrawal = function () {
            $scope.submitted = true;

            if ($scope.withdrawFundForm.$valid && $scope.withdraw_amount > 0) {

                $scope.showPageLoader();
                $('#confirm_withdrawal_modal').modal('hide');
                $('#withdrawPartiallyModal').modal('hide');
                $scope.stopLoading("#partialWithdrawConfirmButton");
                $scope.redirectToOrderExecution($scope.investmentType, $scope.withdraw_amount, $scope.fundName, 'PARTIALWITHDRAWAL');
            } else {
                onWithdrawError($scope, "Please enter correct withdraw amount");
            }
        }

        $scope.submitWithdrawFundForm = async function () {
            $scope.submitted = true;

            if ($scope.withdrawFundForm.$valid) {
                $scope.widthDrawAmount = $scope.withdraw_amount;
                var eventData = {
                    'fundName': $scope.fundName.toLowerCase()
                };
                await analyticsService._push_custom_event_data_to_datalayer('withdraw-confirm-modal-opened', eventData);

                $scope.withdrawAmount = false;
                $scope.withdrawSummery = true;

                // var brokerSessionObject = sessionService.get('sessionObject');
                // var data = {
                //     investingMode: $scope.investingMode,
                //     withdrawalAmount: $scope.widthDrawAmount,
                //     fundName: $scope.withdrawFundName,
                //     adviserUsername: $scope.withdrawFundAdviserUsername,
                //     brokerAuthentication: {
                //         "sessionId": sessionService.get("brokerName"),
                //         "transactionId": JSON.stringify({
                //             "groupId": brokerSessionObject.groupId,
                //             "sessionId": brokerSessionObject.sessionKey,
                //             "transactionId": brokerSessionObject.jKey
                //         })
                //     }
                // };
                // $scope.showLoading("#partialWithdrawButton");
                // WdHttpService._get_withdraw(data)
                //     .then(async function(response) {
                //         if (response.status == 200) {
                //             $scope.withdrawAmount = false;
                //             $scope.withdrawSummery = true;
                //             $scope.actualWithDrawAmount = 0;

                //             angular.forEach($scope.withdrawSharesDetails, function(value, key) {
                //                 $scope.actualWithDrawAmount += parseFloat(value.currentMarketValue);
                //             });
                //             $scope.actualWithDrawAmount = $scope.actualWithDrawAmount.toFixed(2);
                //         }

                //         $scope.stopLoading("#partialWithdrawButton");
                //     }).catch(error => {
                //         $scope.stopLoading("#partialWithdrawButton");
                //         onWithdrawError($scope, error);
                // });
            } else {
                return false;
            }
        }

        $scope.reInitiateWithdrawal = function () {
            $scope.withdrawAmount = true;
        }

        $scope.cancelWithdrawal = function () {
            //TODO reset all variables
            angular.element(document.querySelector(".lds-ellipsis")).removeClass("dw-inline-block");
            angular.element(document.querySelector(".dw-sign-btn")).removeClass("dw-none");
            $('#withdrawPartiallyModal').modal('hide');
        }

        $scope.exitModalOpen = async function () {
            $scope.showPageLoader();
            $scope.exitFundName = $scope.fundName;
            var eventData = {
                'fundName': $scope.fundName.toLowerCase()
            };
            await analyticsService._push_custom_event_data_to_datalayer('clicked-exit', eventData);
            $scope.redirectToOrderExecution($scope.investmentType, 0, $scope.fundName, 'UNSUBSCRIPTION');
        }

        $scope.addMoreModalOpen = async function () {
            $scope.addMoreFundValue = $scope.netPortfolioValue;;
            $scope.addMoreFundName = $scope.fundName;
            $scope.addMoreFundMode = $scope.investingMode;
            $scope.addMoreAdviserUsername = $scope.adviserUsername;
            $scope.buyMoreError = false;
            $scope.buyMoreConfirmError = false;
            $scope.buyMoreFund = true;
            $scope.buyFundData = false;
            $scope.congratsData = false;
            $scope.lumpAmount = '';

            if ($scope.investmentAmtOriginally) {
                $scope.$evalAsync();
                await $('#paymentModal').modal('show');
                var eventData = {
                    'fundName': $scope.fundName.toLowerCase()
                };
                await analyticsService._push_custom_event_data_to_datalayer('buy-more-fee-payment-modal-opened', eventData);

            } else {
                $scope.showProcessingPopup('Kindly be in good network connectivity, as you might expect delays due to low connectivity.');;
            }
        }


        $scope.trustAction = function () {
            return $sce.trustAsResourceUrl(config.PAYTM_URL);
        };

        $scope.submitInvestingAmount = async function (amount, investmentType = "LUMPSUM") {
            $scope.showLoading('#confirmInvestmentAmount');
            amount = parseInt(amount);
            await WdHttpService._get_dynamodb_user_profile().then(async response => {
                $scope.isMandateRegistered = false;
                if ("advisortoMandateDetails" in response) {
                    if ($scope.adviserUsername in response.advisortoMandateDetails) {
                        $scope.isMandateRegistered = true;
                    }
                }
            })
            $scope.paymentDetails = {};
            $scope.paymentDetails.investmentPurpose = $scope.investmentPurpose;
            $scope.paymentDetails.investmentType = investmentType.toUpperCase();
            $scope.paymentDetails.sipDate = $scope.sipDate;
            if (investmentType == 'SIP') {
                $scope.minimumAmountForAdvisoryPayment = parseInt($scope.investmentSipAmtOriginally);
            } else {
                $scope.minimumAmountForAdvisoryPayment = parseInt($scope.investmentAmtOriginally);
            }

            var validateMoreThanMinLumpsum = amount >= $scope.minimumAmountForAdvisoryPayment;
            if ($scope.fund_details && validateMoreThanMinLumpsum) {
                $scope.paymentDetails.investmentAmount = amount;
                $scope.distributorId = $scope.isAdviser ? $scope.fund_details.adviserUsername : sessionService.get("distributorName");
                await WdHttpService._get_user_advisory_fee_amount(
                    $scope.fundName,
                    $scope.fund_details.adviserUsername,
                    $scope.distributorId,
                    $scope.paymentDetails.investmentAmount,
                    $scope.investmentPurpose,
                    $scope.investingMode,
                    $scope.paymentDetails.investmentType
                ).then(async response => {
                    // if response.data.feeAmount is Zero then call is_fee_paid
                    $scope.paymentDetails.fee_key = response.data.key;
                    $scope.paymentDetails.feeAmount = response.data.feeAmount;
                    var eventData = {
                        'fundName': $scope.fundName.toLowerCase()
                    };
                    if ($scope.paymentDetails.feeAmount == 0) {
                        var data = {
                            purpose: $scope.investmentPurpose,
                            investingMode: $scope.investingMode,
                            investmentAmount: $scope.paymentDetails.investmentAmount,
                            investmentType: $scope.paymentDetails.investmentType,
                            fundName: $scope.fundName,
                            adviserUsername: $scope.fund_details.adviserUsername,
                            sipDay: $scope.paymentDetails.sipDate ? $scope.paymentDetails.sipDate : 0
                        }
                        await WdHttpService._is_fee_paid(data)
                            .then(async response => {
                                await analyticsService._push_custom_event_data_to_datalayer('fee-amount-zero-buy-more-' + $scope.investmentPurpose.toLowerCase(), eventData);
                                if (config[$scope.brokerName])
                                    window.location.href = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + response.data.orderId + "&action=order-placement&path=" + window.location.origin;
                                else {
                                    // considering its a offline broker
                                    window.location.href = '/order-placement' + "?orderId=" + response.data.orderId + "&action=order-placement&path=" + window.location.origin;
                                }
                            }).catch(error => {
                                $scope.showErrorPopup(error);
                                $scope.$evalAsync();
                            });
                    } else {
                        // display the payment display in UI 
                        $scope.paymentDetails.gstAmt = ($scope.paymentDetails.feeAmount * .18).toFixed(2);
                        $scope.paymentDetails.payment_charges = 0;
                        $scope.paymentDetails.totalAmt = parseFloat($scope.paymentDetails.feeAmount) + parseFloat($scope.paymentDetails.gstAmt) + parseFloat($scope.paymentDetails.payment_charges);
                        $scope.paymentDetails.totalAmt = $scope.paymentDetails.totalAmt.toFixed(2);
                        analyticsService._push_custom_event_data_to_datalayer('buy-more-fee-initiated-' + $scope.investmentPurpose.toLowerCase(), eventData);
                        $scope.addMorePaymentModal = false;
                        $scope.paymentDetailModal = true;
                    }
                }).catch(error => {
                    console.log(error);
                    $scope.showErrorMessageInSubscribeForm(error);
                })
            } else if (!validateMoreThanMinLumpsum) {
                $scope.showErrorMessageInSubscribeForm("Sorry, you have entered an amount less than the minimum required amount to invest, i.e. " + $scope.minimumAmountForAdvisoryPayment);
            }
            $scope.stopLoading('#confirmInvestmentAmount');
        }


        $scope.selectPayment = async function (paymentGateway) {
            if (!$scope.paymentDetails || !$scope.fund_details || !$scope.distributorId) {
                if (!$scope.paymentDetails)
                    $scope.showErrorPopup('Payment Details are incomplete, please reach out to us at support@wealthdesk.in or +91 8588 00 8835');
                if (!$scope.fund_details)
                    $scope.showErrorPopup('WealthBasket Details not found, please reach out to us at support@wealthdesk.in or +91 8588 00 8835');
                if (!$scope.distributorId)
                    $scope.showErrorPopup('Identifier is missing, please reach out to us at support@wealthdesk.in or +91 8588 00 8835');
                return;
            }
            if (paymentGateway == 'paytm') {
                $scope.createPaytmOrder($scope.paymentDetails, $scope.fund_details, $scope.distributorId)
            } else if (paymentGateway == 'enach') {
                if ($scope.isMandateRegistered) {
                    $scope.executeExistingMandate($scope.paymentDetails, $scope.fund_details);
                } else {
                    $scope.registerENachFlow($scope.paymentDetails, $scope.fund_details, $scope.distributorId)
                }
            }
        }

        //register mandate & open the popup or 
        $scope.registerENachFlow = async function (paymentDetails, fund_details, distributorId) {
            $scope.showPageLoader();
            var deploymentDetails = await WdHttpService._get_deployment_details(await WdHttpService._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
            const brokerBasedApiUrl = deploymentDetails.apiUrl;
            $scope.enach_data_request = {
                "adviserUsername": fund_details.adviserUsername,
                "distributor_id": distributorId,
                "fee_amount": paymentDetails.feeAmount,
                "fundName": fund_details.fundName,
                "gst_amount": paymentDetails.gstAmt,
                "investment_amount": paymentDetails.investmentAmount,
                "investment_type": paymentDetails.investmentType,
                "key": paymentDetails.fee_key,
                "period": fund_details.feePeriod,
                "purpose": paymentDetails.investmentPurpose,
                "sipDay": paymentDetails.sipDate ? $scope.sipDate : 0,
                "callback_url": brokerBasedApiUrl,
                "caller_domain": location.host
            };
            await WdHttpService._post_mandate_registration($scope.enach_data_request)
                .then(response => {
                    let mandateData = response;
                    if (navigator.userAgent.includes('wv')) { //android webview check 
                        mandateData.features.enableNewWindowFlow = false;
                    }
                    $.pnCheckout(mandateData);
                    if (mandateData.features.enableNewWindowFlow) {
                        pnCheckoutShared.openNewWindow();
                    }
                    $scope.$evalAsync();
                }).catch(error => {
                    $scope.showErrorMessagePayment(error);
                    $scope.hidePageLoader();
                    $scope.$evalAsync();
                });
        }

        $scope.showErrorMessagePayment = function (message) {
            $scope.errorMessage = true;
            $scope.confirmErrorMessage = message;
            $timeout(function () {
                $scope.errorMessage = false;
            }, 5000);
        }

        //mandate check if status completed
        $scope.executeExistingMandate = async function (paymentDetails, fund_details) {
            $scope.showPageLoader();
            $scope.data_request = {
                "fundName": fund_details.fundName,
                "adviserUsername": fund_details.adviserUsername,
                "investingMode": $scope.investingMode,
                "distributorUsername": $scope.distributorUsername ? $scope.distributorUsername : fund_details.adviserUsername,
                "investingPurpose": paymentDetails.investmentPurpose,
                "investment_type": paymentDetails.investmentType,
                "investment_amount": paymentDetails.investmentAmount,
                "sipDay": paymentDetails.sipDate ? $scope.sipDate : 0,
                "fee_amount": paymentDetails.feeAmount,
                "gst_amount": paymentDetails.gstAmt,
                "key": paymentDetails.fee_key
            };
            await WdHttpService._post_existing_mandate($scope.data_request)
                .then(response => {
                    let mandateOrderId = response.orderId;
                    window.location.href = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + mandateOrderId + "&action=order-placement&path=" + window.location.href;
                    $scope.$evalAsync();
                }).catch(error => {
                    $scope.showErrorMessagePayment(error);
                    $scope.hidePageLoader();
                });
        }

        $scope.createPaytmOrder = async function (paymentDetails, fund_details, distributorId) {
            $scope.showPageLoader();
            var deploymentDetails = await WdHttpService._get_deployment_details(await WdHttpService._get_deployment_id(getProfileValueFor('custom:brokerName1', sessionService.get('profile'))));
            const brokerBasedApiUrl = deploymentDetails.apiUrl + '/investor/';
            $scope.paytm_data_request = {
                TXN_AMOUNT: paymentDetails.totalAmt,
                FEE_AMOUNT: paymentDetails.feeAmount,
                GST_AMOUNT: paymentDetails.gstAmt,
                PAYMENT_CHARGES: paymentDetails.payment_charges,
                CALLBACK_URL: brokerBasedApiUrl + config.CALLBACK_URL,
                CALLER_DOMAIN: location.host,
                CHANNEL_ID: config.CHANNEL_ID,
                INDUSTRY_TYPE_ID: config.INDUSTRY_TYPE_ID,
                WEBSITE: config.WEBSITE,
                FUND_NAME: fund_details.fundName,
                ADVISER_USERNAME: fund_details.adviserUsername,
                "investment_amount": paymentDetails.investmentAmount,
                "purpose": paymentDetails.investmentPurpose,
                "investment_type": paymentDetails.investmentType,
                "sipDay": paymentDetails.sipDate ? $scope.sipDate : 0,
                "key": paymentDetails.fee_key,
                "distributor_id": distributorId
            };
            await WdHttpService._create_order_checksum($scope.paytm_data_request)
                .then(response => {
                    $scope.paytm_data = response.data;
                    $scope.$evalAsync();
                    submitForm($scope);
                }).catch(error => {
                    $scope.showErrorMessagePayment(error);
                    $scope.hidePageLoader();
                });
        }

        function submitForm($scope, recursion = true) {
            setTimeout(() => {
                if (document.getElementById("btnPaytmSubmit")) {
                    document.getElementById("btnPaytmSubmit").click();
                } else {
                    if (recursion) {
                        submitForm($scope, false);
                    } else {
                        $scope.showErrorPopup("Sorry, we are not able to submit the details. Please try again or contact support.");
                    }
                }
            }, 1000);
        }

        $scope.addMoreFeePaymentSubmit = function () {
            $scope.investmentPurpose = 'ADDITIONALSUBSCRIPTION'; //EQUITYSUBSCRIPTION, ADDITIONALSUBSCRIPTION, RENEWAL
            $scope.sipDate = undefined;
            $scope.investingMode = 'REAL';
            const investingAmountForFeePayment = $("#totalInvAmountForFee").val().replace(/,/g, '');
            $scope.submitInvestingAmount(investingAmountForFeePayment, $scope.investmentType);
        }

        $scope.getFundDetails = async function () {
            var data = {
                q: "fundName:" + $scope.fundName,
                f: "web_admin:" + $scope.webadminName
            }
            $scope.showLoading("#addMoreButton");
            await WdHttpService._get_funds(data)
                .then(async function (response) {
                    if (response.status == 200) {
                        var fund_details;
                        // This if condition is coded due to a server side bug to be fixed yet.
                        if (response.data.Items.length > 1) {
                            response.data.Items.forEach(fund => {
                                if (fund.fundName == $routeParams.fundname)
                                    fund_details = fund;
                            });
                        } else
                            fund_details = response.data.Items[0];

                        $scope.fundIcon = fund_details.fundIcon;

                        $scope.fund_details = fund_details;

                        angular.forEach(fund_details.childFund, function (value, key) {
                            $scope.sipList.push({
                                "fundName": value.fundName,
                                "minSipAmount": value.minAmount
                            })
                        });
                    }

                    if ($scope.investmentType == 'SIP') {
                        $scope.investmentSipAmt = $scope.fund_details.childFund[0].minAmount;
                        $scope.investmentSipAmtOriginally = $scope.fund_details.childFund[0].minAmount;
                        for (var i = 0; i < $scope.fund_details.childFund.length; i++) {
                            if ($scope.fund_details.childFund[i].minAmount <= $scope.investmentSipAmt) {
                                $scope.investmentSipAmtOriginally = $scope.fund_details.childFund[i].minAmount;
                                $scope.investmentSipAmt = $scope.fund_details.childFund[i].minAmount;
                            }
                        }
                        $scope.investmentAmt = parseInt($scope.investmentSipAmt);
                        $scope.investmentAmtOriginally = parseInt($scope.investmentSipAmt);
                    } else {
                        if (fund_details.minAdditionalLumpsum) {
                            $scope.investmentAmt = parseInt(fund_details.minAdditionalLumpsum);
                            $scope.investmentAmtOriginally = parseInt(fund_details.minAdditionalLumpsum);
                        } else {
                            $scope.investmentAmt = parseInt(fund_details.minAmount);
                            $scope.investmentAmtOriginally = parseInt(fund_details.minAmount);

                        }
                        $scope.hidePageLoader();
                    }
                }).catch(error => {
                    console.error(error);
                    $scope.hidePageLoader();
                });
            $scope.stopLoading("#addMoreButton");
        }

        $scope.downloadPDF = async function () {

            var data = {
                investingMode: $scope.investingMode,
                benchmark: $scope.benchmark
            }
            $scope.showPageLoader();
            var pdfUrl = await WdHttpService._holdings_export($routeParams.adviser, $routeParams.fund, data)
                .catch(error => {
                    $scope.showErrorPopup(error);
                    return undefined;
                });

            if (pdfUrl) {
                var a = document.createElement('a');
                a.href = pdfUrl;
                a.click();
            }
            $scope.hidePageLoader();
        }

        $scope.redirectToOrderExecution = function (investmentType, investingAmount, fundName, purpose) {
            $scope.showPageLoader();
            var data = {
                purpose: purpose,
                investingMode: $scope.investingMode,
                investmentAmount: investingAmount,
                investmentType: investmentType,
                fundName: fundName,
                adviserUsername: $scope.adviserUsername,
                sipDay: 0
            }

            WdHttpService._is_fee_paid(data)
                .then(async response => {
                    var eventData = {
                        'fundName': fundName.toLowerCase()
                    };
                    await analyticsService._push_custom_event_data_to_datalayer('fund-action-fee-paid-' + purpose.toLowerCase(), eventData);
                    window.location.href = config[$scope.brokerName].orderPlacementUrl + "?orderId=" + response.data.orderId + "&action=order-placement&path=" + window.location.origin;
                }).catch(error => {
                    $scope.hidePageLoader();
                    $scope.showErrorPopup(error);
                });
        }

        $scope.showErrorMessageInSubscribeForm = function (message) {
            $scope.subStatus = true;
            $scope.subcritionErrorMsg = message;
            $timeout(function () {
                $scope.subStatus = false;
            }, 10 * 1000);
            $scope.$evalAsync();
        }

        function onWithdrawError($scope, error) {
            $scope.confirmWithdrawError = true;
            if (typeof error == 'string')
                $scope.confirmWithdrawErrorMsg = error;
            else
                $scope.confirmWithdrawErrorMsg = 'Error while communicating with server.';
            $timeout(function () {
                $scope.confirmWithdrawError = false;
            }, 5000);
        }

    }
]);